import { render } from "./CreateOffering.vue?vue&type=template&id=69a70add"
import script from "./CreateOffering.vue?vue&type=script&lang=js"
export * from "./CreateOffering.vue?vue&type=script&lang=js"
script.render = render

export default script